import { Filter, SUFIXO_FIELD } from "src/framework/commons/FilterUtil";
import { IBaseManager } from "src/framework/components/base/DataGrid/types";
import { IDataRequest, IDataResponse, IHttpClient, STATUS_CODE } from "src/framework/providers/api";
import { ProjetoCalcular, SITUACAO } from "./types";
import { FieldFilter, LESS_CRITERIA_LIST_ITEM, LESS_EQUAL_CRITERIA_LIST_ITEM, MORE_CRITERIA_LIST_ITEM, MORE_EQUAL_CRITERIA_LIST_ITEM, ResourcePaths } from "src/framework/store/DataGridStore";
import { notifierStore } from "src/framework/store/NotifierStore";
import { Componente } from "../componentes/types";
import { calculoProjetoRealizado$ } from "src/store/vendas/projetos/store";

export type TipoUpload = "proposta" | "componentes"


export const paths: ResourcePaths = {
    list: "projetos",
    create: "projetos",
    read: "projetos",
    update: "projetos",
    delete: "projetos",
}

export const DATA_INTEGRACAO_INICIAL_FIELD: FieldFilter = {
    name: "data_integracao",
    index: 1,
    criteriaList: [
        MORE_EQUAL_CRITERIA_LIST_ITEM,
        MORE_CRITERIA_LIST_ITEM,
    ]
}

export const DATA_INTEGRACAO_FINAL_FIELD: FieldFilter = {
    name: "data_integracao",
    index: 2,
    criteriaList: [
        LESS_EQUAL_CRITERIA_LIST_ITEM,
        LESS_CRITERIA_LIST_ITEM,
    ]
}

export const DATA_CRIACAO_INICIAL_FIELD: FieldFilter = {
    name: "created_at",
    index: 3,
    criteriaList: [
        MORE_EQUAL_CRITERIA_LIST_ITEM,
        MORE_CRITERIA_LIST_ITEM,
    ]
}

export const DATA_CRIACAO_FINAL_FIELD: FieldFilter = {
    name: "created_at",
    index: 4,
    criteriaList: [
        LESS_EQUAL_CRITERIA_LIST_ITEM,
        LESS_CRITERIA_LIST_ITEM,
    ]
}

export const SITUACAO_FIELD: FieldFilter = {
    name: "situacao",
    index: 5,
    criteriaList: [],
}

export const COMPONENTE_FIELD: FieldFilter = {
    name: "componente",
    index: 6,
    criteriaList: []
}

export const CIDADE_FIELD: FieldFilter = {
    name: "cidade_id",
    index: 7,
    criteriaList: []
}

export const REVENDA_FIELD: FieldFilter = {
    name: "revenda_id",
    index: 8,
    criteriaList: []
}

export const DISTRIBUIDOR_FIELD: FieldFilter = {
    name: "distribuidor_id",
    index: 9,
    criteriaList: []
}

export const EV_FIELD: FieldFilter = {
    name: "ev_id",
    index: 10,
    criteriaList: []
}

export const ANALISTA_FIELD: FieldFilter = {
    name: "analista_id",
    index: 11,
    criteriaList: []
}

export const DATA_ETAPA_INICIO_FIELD: FieldFilter = {
    name: "data_etapa_venda_more_equal",
    index: 12,
    criteriaList: []
}

export const DATA_ETAPA_FINAL_FIELD: FieldFilter = {
    name: "data_etapa_venda_less_equal",
    index: 13,
    criteriaList: []
}

export const ETAPA_VENDA_FIELD: FieldFilter = {
    name: "etapa_venda_in",
    index: 14,
    criteriaList: []
}

export const PRIORIDADE_FIELD: FieldFilter = {
    name: "prioridade",
    index: 15,
    criteriaList: [],
}

export const ORIGEM_FIELD: FieldFilter = {
    name: "origem",
    index: 16,
    criteriaList: [],
}

export const AUTOCOMPLETE_CIDADE: Filter[] = [
    {
        field: "nome",
        value: "",
        criteria: SUFIXO_FIELD.LIKE,
        isDefaultSearch: true,
        orField: [{
            field: "estado_id",
            criteria: SUFIXO_FIELD.LIKE
        }]
    }
]

export const AUTOCOMPLETE_COMPONENTE: Filter[] = [
    {
        field: "modelo",
        value: "",
        criteria: SUFIXO_FIELD.LIKE,
        isDefaultSearch: true,
        orField: [{
            field: "id",
            criteria: "",
            isNumber: true
        }]
    }
]

export const AUTOCOMPLETE_REVENDA: Filter[] = [
    {
        field: "fantasia",
        value: "",
        criteria: SUFIXO_FIELD.LIKE,
        isDefaultSearch: true,
        orField: [
            {
                field: "cnpj_cpf",
                criteria: SUFIXO_FIELD.LIKE,
                isNumber: true,
            },
            {
                field: "nome",
                criteria: SUFIXO_FIELD.LIKE,
            },
        ]
    },
    {
        field: "tipo_conta_id_in",
        value: "3,4"
    }
];

export const AUTOCOMPLETE_DISTRIBUIDOR: Filter[] = [
    {
        field: "fantasia",
        value: "",
        criteria: SUFIXO_FIELD.LIKE,
        isDefaultSearch: true,
        orField: [
            {
                field: "cnpj_cpf",
                criteria: SUFIXO_FIELD.LIKE,
                isNumber: true,
            },
            {
                field: "nome",
                criteria: SUFIXO_FIELD.LIKE,
            },
        ]
    },
    {
        field: "tipo_conta_id_in",
        value: "1,2"
    }
];

export const AUTOCOMPLETE_EV: Filter[] = [
    {
        field: "nome",
        value: "",
        criteria: SUFIXO_FIELD.LIKE,
        isDefaultSearch: true,
        orField: [
            {
                field: "cnpj_cpf",
                criteria: SUFIXO_FIELD.LIKE,
                isNumber: true,
            },
        ]
    },
    {
        field: "tipo_conta_id",
        value: "6"
    }
];

export const AUTOCOMPLETE_ANALISTA: Filter[] = [
    {
        field: "nome",
        value: "",
        criteria: SUFIXO_FIELD.LIKE,
        isDefaultSearch: true,
        orField: [
            {
                field: "cnpj_cpf",
                criteria: SUFIXO_FIELD.LIKE,
                isNumber: true,
            },
        ]
    },
    {
        field: "tipo_conta_id",
        value: "10"
    }
];

export const FILTER: Filter[] = [
    {
        field: "codigo_venda_in",
        value: "",
        label: "Código venda (Use vírgula como separador)",
        isDefaultSearch: true,
        isNumber: false,
    },
    {
        field: DATA_INTEGRACAO_INICIAL_FIELD.name,
        value: null,
    },
    {
        field: DATA_INTEGRACAO_FINAL_FIELD.name,
        value: null,
    },
    {
        field: DATA_CRIACAO_INICIAL_FIELD.name,
        value: null,
    },
    {
        field: DATA_CRIACAO_FINAL_FIELD.name,
        value: null,
    },
    {
        field: SITUACAO_FIELD.name,
        value: String(SITUACAO.PENDENTES),
    },
    {
        field: COMPONENTE_FIELD.name,
        value: null,
        arrayField: "id"
    },
    {
        field: CIDADE_FIELD.name,
        value: null,
        arrayField: "id"
    },
    {
        field: REVENDA_FIELD.name,
        value: null,
        arrayField: "id"
    },
    {
        field: DISTRIBUIDOR_FIELD.name,
        value: null,
        arrayField: "id"
    },
    {
        field: EV_FIELD.name,
        value: null,
        arrayField: "id"
    },
    {
        field: ANALISTA_FIELD.name,
        value: null,
        arrayField: "id"
    },
    {
        field: DATA_ETAPA_INICIO_FIELD.name,
        value: null
    },
    {
        field: DATA_ETAPA_FINAL_FIELD.name,
        value: null
    },
    {
        field: ETAPA_VENDA_FIELD.name,
        value: ["sla_engenharia"]
    },
    {
        field: PRIORIDADE_FIELD.name,
        value: null
    },
    {
        field: ORIGEM_FIELD.name,
        value: "V2",
    }
];

export const TAB_DOCUMENTOS = "documentos"
export const TAB_COMPONENTES = "componentes"

class VerticaisManager implements IBaseManager {

    filter: Filter[] = [];
    cachedComponentes: Componente[] = [];

    constructor(private readonly paths: ResourcePaths, private readonly provider: IHttpClient, private readonly providerNoLoading: IHttpClient) { }

    static paths: ResourcePaths = {
        list: "projetos",
        create: "projetos",
        read: "projetos",
        update: "projetos",
        delete: "projetos",
    }

    async getCachedComponentes(): Promise<void> {
        try {
            const request: IDataRequest = {
                url: "componentes/cache?includes=atributos"
            }

            const response: IDataResponse<Componente[]> = await this.providerNoLoading.get(request);

            if (response.statusCode === STATUS_CODE.OK) {
                this.cachedComponentes = response.data;
            }
        } catch (error) {

        }
    }

    async list(): Promise<IDataResponse> {
        try {
            const request: IDataRequest = {
                url: "projetos",
            }

            const response = await this.provider.get(request);

            if (response.statusCode === STATUS_CODE.OK) {
                return {
                    message: response.message,
                    data: response.data?.rows,
                    statusCode: response.statusCode
                }
            }

            return {
                data: null,
                message: "Error",
                statusCode: 400
            }
        } catch (error) {
            return {
                data: null,
                message: "Error",
                statusCode: 400
            }
        }
    }

    async save(param: { row: any; primaryKey?: string | number | undefined; }): Promise<IDataResponse> {
        try {
            const isUpdate: boolean = param?.primaryKey && param?.primaryKey !== "" ? true : false;
            const url: string = isUpdate ? `${this.paths.update}/${param.primaryKey}` : `${this.paths.create}`;

            const requestConfig: IDataRequest = {
                url: `${url}`,
                data: param.row,
            };

            let response: IDataResponse = isUpdate
                ? await this.provider.put(requestConfig)
                : await this.provider.post(requestConfig);

            if ([STATUS_CODE.OK, STATUS_CODE.CREATED].includes(response.statusCode)) {
                // notifierStore.setNotifier({
                //     content: "Registro salvo com sucesso!!",
                //     title: "Aviso",
                //     timeOut: 2500,
                //     onClose: () => notifierStore.setOpen(false),
                // });

                // notifierStore.setOpen(true);
                return response;
            }
            return {
                data: null,
                statusCode: response.statusCode,
                message: response.message,
            };
        } catch (error) {
            throw error;
        }
    }

    async find<T = any>(param: { primaryKey?: number | string; includes?: string[]; }): Promise<IDataResponse<T> | null> {
        try {
            const _includesList: string[] = param?.includes ? param.includes : [];

            const _includes =
                _includesList.length > 0 ? `/?includes=${_includesList.join(",")}` : "";

            const requestConfig: IDataRequest = {
                url: `${this.paths.read}/${param.primaryKey}${_includes}`,
            };

            const response: IDataResponse = await this.provider.get(requestConfig);

            if (response.statusCode === STATUS_CODE.OK) {
                return response.data.length > 0 ? response : null;
            }

            return null;
        } catch (error) {
            return null;
        }
    };

    async delete(primaryKey: number): Promise<IDataResponse> {
        try {
            const requestConfig: IDataRequest = {
                url: `${this.paths.delete}/${primaryKey}`,
            };

            const response: IDataResponse = await this.provider.delete(requestConfig);

            if (response.statusCode === STATUS_CODE.OK) {
                notifierStore.setNotifier({
                    content: "Registro removido com sucesso!!",
                    title: "Aviso",
                    timeOut: 2500,
                    onClose: () => notifierStore.setOpen(false),
                });
                notifierStore.setOpen(true);
                return response;
            }

            return response;
        } catch (error) {
            return {
                data: null,
                message: "Error",
                statusCode: 400
            };
        }
    }

    async downloadAnexos(id: number): Promise<IDataResponse> {
        try {
            const request: IDataRequest = {
                url: `/projetos/anexos/zip/${id}`,
            }

            return await this.provider.getFile(request);
        } catch (error) {
            return {
                data: null,
                message: "Erro ao efetuar o download de anexos",
                statusCode: 404
            }
        }
    }

    async export(): Promise<void> { }

    parseSituacao(situacao: string): string {

        switch (situacao) {
            case "registrado":
                return "Registrado"
            case "finalizado":
                return "Finalizado"
            case "expirado":
                return "Expirado"
            case "cancelado":
                return "Cancelado"
        }

        return "";
    }

    parseEtapaVenda(etapaVenda: string): string {
        switch (etapaVenda) {
            case "sla_engenharia":
                return "SLA Engenharia";
            case "pre_orcamento":
                return "Pré-orçamento";
            case "aguardando_pagamento":
                return "Aguardando Pagto";
            case "negociacao":
                return "Negociação";
            case "aguardando_faturamento":
                return "Aguardando Fat.";
            case "faturado":
                return "Faturado";
            case "em_transito":
                return "Em transito";
        }

        return "ND";
    }

    setDefaultFilter(): void {
        this.setFilter([
            {
                field: "codigo_venda_in",
                value: "",
                label: "Código venda (Use vírgula como separador)",
                isDefaultSearch: true,
                isNumber: false,
            },
        ])
    }

    setFilter(filter: Filter[]): void {
        this.filter = filter
    }

    static parseTipoUpload(tipo: TipoUpload): string {
        switch (tipo) {
            case "proposta":
                return "Proposta";
            case "componentes":
                return "Componentes";
        }
    }

    async calcular(projeto: ProjetoCalcular): Promise<IDataResponse> {
        try {
            const request: IDataRequest = {
                url: "/projetos/calcular",
                data: projeto
            }

            const response: IDataResponse = await this.provider.post(request);

            if (response.statusCode !== STATUS_CODE.OK) {
                notifierStore.setNotifier({
                    content: "Não foi possível calcular os valores do projeto. Verifique os dados informados e tente novamente.",
                    title: "Atenção!",
                    timeOut: 3000,
                    onClose: () => notifierStore.setOpen(false),
                });
                notifierStore.setOpen(true);
                calculoProjetoRealizado$.next(false);
                return response;
            }
            
            calculoProjetoRealizado$.next(true);
            return response;
        } catch (error) {
            calculoProjetoRealizado$.next(false);
            return {
                data: null,
                message: "Erro ao efetuar o cálculo",
                statusCode: 404
            }
        }

    }

    async cancelar(projetos: string[]): Promise<IDataResponse> {
        try {
            const request: IDataRequest = {
                url: "/projetos/cancelar",
                data: {
                    projetos: projetos
                }
            }

            return await this.provider.post(request);
        } catch (error) {
            return {
                data: null,
                message: "Erro ao cancelar projeto(s)",
                statusCode: 404
            }
        }
    }

    async finalizar(codigoVenda: string, triangular: boolean): Promise<IDataResponse> {
        try {
            const request: IDataRequest = {
                url: "/projetos/enviar_pagamento",
                data: {
                    codigo_venda: codigoVenda,
                    nota_fiscal_triangular: triangular
                }
            }

            return await this.provider.post(request);
        } catch (error) {
            return {
                data: null,
                message: "Erro ao enviar pagamento do projeto(s)",
                statusCode: 404
            }
        }
    }

    async prioridade(id: number, prioridade: string): Promise<IDataResponse> {
        try {
            const request: IDataRequest = {
                url: `/projetos/prioridade/${id}`,
                data: {
                    prioridade,
                }
            }

            return await this.provider.put(request);
        } catch (error) {
            return {
                data: null,
                message: "Erro ao atualizar prioridade do projeto",
                statusCode: 404
            }
        }
    }

    async solicitacaoPausa(id: number, solicitacao: string, envia_email: boolean, envia_email_interno: boolean): Promise<IDataResponse> {
        try {
            const request: IDataRequest = {
                url: `/projetos/solicitar_pausa/${id}`,
                data: {
                    solicitacao,
                    envia_email,
                    envia_email_interno,
                }
            }

            return await this.provider.put(request);
        } catch (error) {
            return {
                data: null,
                message: "Erro ao solicitar pausa do projeto",
                statusCode: 404
            }
        }
    }

    async getGruposEstrutura(): Promise<IDataResponse> {
        try {
            const request: IDataRequest = {
                url: "/estruturas/grupos",
            }
            return await this.provider.get(request);
        } catch (error) {
            return {
                data: null,
                message: "Erro ao buscar grupos de estrutura",
                statusCode: 404
            }
        }
    }

    addComponente(novosComponentes: Componente[], listaComponenteCache: Componente[]): Componente[] {
        const _listaComponenteCache = listaComponenteCache
        for (let _novo of novosComponentes) {
            if (_listaComponenteCache.findIndex((c) => c.id === _novo.id) === -1) {
                _listaComponenteCache.push(_novo);
            }
        }
        return _listaComponenteCache;
    }
}

export { VerticaisManager }